// hooks/useCotaUsuario.ts
import { useState, useEffect } from "react";
import { arquivoService } from "../services/arquivoService";

export const useArquivos = (
  cotaUsuarioId: number | undefined | null,
  fetch: boolean
) => {
  const [isLoading, setIsLoading] = useState(true);
  const [arquivos, setArquivos] = useState<any | undefined>(undefined);

  useEffect(() => {
    const fetchArquivos = async () => {
      if (cotaUsuarioId && fetch) {
        setIsLoading(true);
        try {
          const data = await arquivoService(cotaUsuarioId);
          if (data) {
            setArquivos(data);
          } else {
            console.error("Dados não encontrados arquivos");
          }
        } catch (error) {
          console.error("Erro ao buscar arquivos:", error);
        } finally {
          setIsLoading(false);
        }
      } else {
        setIsLoading(false);
      }
    };

    fetchArquivos();
  }, [cotaUsuarioId, fetch]); // Dependência de cotaUsuarioId e fetch para garantir que a chamada seja feita quando necessário

  return { isLoading, arquivos };
};
